import React from "react";
import CommonTable from "./CommonTable";
import dayjs from "dayjs";
import { convertUtcToIst } from "../../../helpers/utility";

const IoData = ({ data }) => {
  const columns = [
    {
      title: "Time Done",
      dataIndex: "process_time",
      key: "process_time",
      render: (value) => convertUtcToIst(value, true, true),
    },
    {
      title: "Oral Tube Intake",
      dataIndex: "oral_tube_intake",
      key: "oral_tube_intake",
    },
    {
      title: "Flush",
      dataIndex: "flush",
      key: "flush",
    },
    {
      title: "IV Fluids",
      dataIndex: "iv_fluids",
      key: "iv_fluids",
    },
    {
      title: "Hourly Intake",
      dataIndex: "hourly_intake",
      key: "hourly_intake",
    },
    {
      title: "UO",
      dataIndex: "uo",
      key: "uo",
    },
    {
      title: "GI Losses",
      dataIndex: "gi_losses",
      key: "gi_losses",
    },
    {
      title: "Drain",
      dataIndex: "drain",
      key: "drain",
    },
    {
      title: "Hourly Output",
      dataIndex: "hourly_output",
      key: "hourly_output",
    },
  ];
    const totals = (data || []).reduce(
    (acc, row) => {
      const toNumber = (v) => (v ? Number(v) : 0);

      const intake =
        toNumber(row.oral_tube_intake) +
        toNumber(row.flush) +
        toNumber(row.iv_fluids) ;

      const output =
        toNumber(row.uo) +
        toNumber(row.gi_losses) +
        toNumber(row.drain) ;

      acc.intake += intake;
      acc.output += output;
      return acc;
    },
    { intake: 0, output: 0 }
  );

  const net = totals.intake - totals.output;

        return (
    <div>
      {data && data.length > 0 && (
        <div
          style={{
            marginBottom: 12,
            display: "flex",
            gap: 16,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <span style={{ fontWeight: 600 }}>
            Total Intake: {totals.intake.toFixed(1)}
          </span>
          <span style={{ fontWeight: 600 }}>
            Total Output: {totals.output.toFixed(1)}
          </span>
        </div>
      )}

      <CommonTable data={data} columns={columns} />
    </div>
  );
};

export default IoData;
